import styled from '@emotion/styled';

export const PairOrderColumn = styled.td`
  padding-bottom: 18px;
  vertical-align: top;
`;

export const PairOrderContent = styled.div`
  p:first-child {
    margin-top: 2px;
  }
`;

export const TextStatus = styled.p`
  margin: 5px 0;
`;
